import Box from '@mui/material/Box'
import { map } from 'lodash'
import { PhotoProvider } from 'react-photo-view'
import 'react-photo-view/dist/react-photo-view.css'
import { ReplyActor } from '../../../../swagger/dto'
import { theme } from '../../../../theme'
import { ImageInRequest } from './ImageInRequest'

export const ImageInRequestList = ({ imageContent, actor }) => {
    return (
        <PhotoProvider>
            <Box
                sx={{
                    width: '100%',
                    display: 'grid',
                    gridTemplateColumns: 'min-content min-content',
                    gap: '16px',
                    justifyItems: actor === ReplyActor.ASSISTANT ? 'start' : 'end',
                    [theme.breakpoints.down('lg')]: {
                        gridTemplateColumns: '1fr',
                    },
                }}>
                {map(imageContent, ({ generation_task_id, image_url }) => (
                    <ImageInRequest
                        key={generation_task_id}
                        isAssistant={actor === ReplyActor.ASSISTANT}
                        tastId={generation_task_id}
                        src={image_url}
                    />
                ))}
            </Box>
        </PhotoProvider>
    )
}
